// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__XmlPw","slick-next":"CustomSlider_slick-next__n7AGv"};